module.exports = __webpack_public_path__ + "img/image-banner-new.519034ab.jpg";